import enLocale from 'element-ui/lib/locale/lang/en'
import list1 from '@/i18n/ELK/list1.js'
import tabs from '@/i18n/ELK/tabs1.js'
import anti1 from '@/i18n/ELK/anti1.js'
import logs1 from '@/i18n/ELK/logs1.js'

export default {
    // 列表点击查看
    ...list1,
    ...logs1,
    ...tabs,
    ...anti1,
    // 垃圾病毒隔离区  
    //  ELK垃圾隔离列表
    wasteInsulate1: {
        tolname10: 'ELKArchive list',
        tolname101: 'Archive list',
        tolname11: 'ELKFilter log', //ELK实时过滤日志
        tolname111: 'Filter log',
        tolname111_syslog: 'Syslog Query',
        tolname111_syslog1: 'QID Domain Email or IP',
        tolname12: 'ELKMessage queue', //ELK实时投递日志
        tolname121: 'Message queue',
        tolname131: 'ELKQueue detail',
        tolname1: 'ELKSpam list',
        tolname: 'Spam list',
        envfrom: 'Envfrom',
        envrcpt: 'Envrcpt',
        ip: 'IP Address',
        attach: 'Attach Name',
        hdrfrom: 'Header from',
        hdrto: 'Header to',
        url: 'Url',
        subject: 'Subject',
        body: 'Body',
        haspass: 'Pass Type',
        bigs: 'Msg Size',
        type: 'Select Type',
        mid: 'mid',
        stage: 'stage',
        status: 'status or why',
        minion_host: 'Cluster Host',
        spam_reason: 'Spam_reason',
        startdate: 'Maildate',
        zhi: 'to',
        isl: 'White List',
        istls: 'Encrypt',
        isout: 'Isout',
        attnum: 'Attnum',
        bccnum: 'Bccnum',
        alinknum: 'Alinknum',
        apt_state: 'APT Status',
        more_operations: 'More operations',
        attachment_size: 'Attachment_size',
        delay_time: "delay_time",
    },
    table: {
        search: 'search',
        more: 'more',
        more1: 'fold',

        tls: 'tls',
        maildate: 'maildate',
        clusterhost: 'cluster host',
        ID: 'id',
        IP: 'ip address',
        ENVFROM: 'envfrom',
        ENVRCPT: 'envrcpt',
        SUBJECT: 'subject',
        SHOW_REASON: 'reason',
        operate: 'operate',
        mailsize: 'size',
        look: 'check',
        download: 'download',
        record: 'Derived Record',
        pass: 'bulk pass',
        pass1: 'bulk delete',
        ENVRCPT1: 'Rcpt num',
        status: 'send status',
        sdata: 'start-data',
        enddata: 'end-data',
        show: 'Show more',
        yin: 'hidden',
        relay: 'relay',
        reason: 'reason',
        wl: 'white list'

    },
    confirm: {
        ok: 'Logout', //退出
        search: 'search',

        cancel: 'Cancel', //取消
        content: 'Are you sure you want to quit the system?', //你确认要退出系统吗
        logout: 'Logout', //
        deliver: 'delivering successful',
        transpond: 'transpond successful',
        refresh: "refresh",
    },
    ...enLocale
}